var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.95 8.60554L16.7722 4.92776L18.9278 1.39999C18.979 1.31592 19.0069 1.21977 19.0087 1.12136C19.0105 1.02296 18.9862 0.925839 18.9381 0.839938C18.8901 0.754037 18.8201 0.682439 18.7353 0.632469C18.6505 0.582499 18.554 0.555952 18.4556 0.555542H1.11111C0.816426 0.555542 0.533811 0.672605 0.325437 0.880979C0.117063 1.08935 0 1.37197 0 1.66665L0 8.33332C0 8.628 0.117063 8.91062 0.325437 9.11899C0.533811 9.32737 0.816426 9.44443 1.11111 9.44443H18.4722C18.5703 9.44441 18.6666 9.41844 18.7514 9.36916C18.8361 9.31987 18.9063 9.24903 18.9549 9.16382C19.0034 9.07861 19.0285 8.98208 19.0277 8.88402C19.0268 8.78597 19 8.68989 18.95 8.60554ZM5.83889 6.76665H5.21667L3.40556 4.35554V6.77221H2.77778V3.33332H3.40556L5.22222 5.74999V3.33332H5.84444L5.83889 6.76665ZM9.35556 3.88888H7.39444V4.71665H9.17222V5.27221H7.39444V6.16665H9.35556V6.72221H6.76667V3.33332H9.35L9.35556 3.88888ZM13.9611 6.75554H13.3333L12.4722 4.20554L11.6111 6.76665H10.9889L9.87778 3.33332H10.5556L11.2889 5.79443L12.1333 3.33332H12.8111L13.6222 5.79443L14.3611 3.33332H15.0444L13.9611 6.75554Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBanner);
export default __webpack_public_path__ + "static/media/new-banner.ff669bb2f3f553ee61b2f20e860f18d2.svg";
export { ForwardRef as ReactComponent };